module.exports = "<div class=\"estate-map-container my-3\"><div class=\"w-100\" id=\"estates-map\"></div></div>";